<template>
  <div>
    <div>
      <el-form :inline="true" :model="listQuery" class="demo-form-inline">
        <el-form-item label="考试名称:">
          <el-select v-model="listQuery.exam_id" clearable placeholder="请选择" @change="getData">
            <el-option
              v-for="item in examList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="考试科目:">
          <el-select v-model="listQuery.subject_id" clearable placeholder="请选择">
            <el-option
              v-for="item in subjectList"
              :key="item.id"
              :label="item.name"
              :value="item.id">
            </el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button type="primary" size="medium" @click="search">查询</el-button>
        </el-form-item>
      </el-form>
    </div>
    <!-- 折线图 -->
    <div class="chart" id="chart">

    </div>
    <div>
      <el-table :data="tableData" stripe style="width: 100%">
        <el-table-column label="序号">
          <template slot-scope="scope">
            {{scope.$index+1}}
          </template>
        </el-table-column>
        <el-table-column prop="stationName" label="考站">
        </el-table-column>
        <el-table-column prop="teacherName" label="评分老师">
        </el-table-column>
        <el-table-column prop="mins" label="考试限时">
          <template slot-scope="scope">
            {{scope.row.examMins}}分钟
          </template>
        </el-table-column>
        <el-table-column prop="timeAvg" label="平均耗时">
        </el-table-column>
        <el-table-column prop="scoreAvg" label="平均成绩">
        </el-table-column>
        <el-table-column prop="studentQuantity" label="考试人数">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <i class="el-icon-search" @click="handleEdit(scope.row)"></i>
          </template>
        </el-table-column>
      </el-table>

    </div>
    <el-dialog title="考站成绩明细" :visible.sync="dialogTableVisible" width="80%">
      <div style="margin: 10px 0">
        <el-row>
          <el-col :span="12"><b>考试：{{this.stationTitle.examName}} </b></el-col>
          <el-col :span="6"><b>考试时间：{{this.stationTitle.time}} </b></el-col>

        </el-row>
        <el-row style="margin-top: 10px">
          <el-col :span="12"> <b>考试项目：{{this.stationTitle.subjectTitle}}</b></el-col>

          <el-col :span="6"><b>考站名称：{{this.stationTitle.stationName}} </b></el-col>
        </el-row>
      </div>
      <el-table :data="stationDetails">
        <el-table-column label="#">
          <template slot-scope="scope">
            {{scope.$index+1}}
          </template>
        </el-table-column>
        <el-table-column prop="studentName" label="考生">
        </el-table-column>
        <el-table-column prop="begin_dt" label="考试时间">
        </el-table-column>
        <el-table-column prop="score" label="成绩">
        </el-table-column>
        <el-table-column prop="time" label="耗时">
        </el-table-column>
        <el-table-column prop="teacherName" label="评价老师">
        </el-table-column>
      </el-table>
    </el-dialog>

  </div>
</template>

<script>
    export default {
        data() {
            return {
                subjectList: [],
                examList: [],
                avgdata:[],
                stationDetails:[],
                stationTitle:{},
                dialogTableVisible:false,
                subjectStr:[],
                studentScoreStr:[],
                scoreAvgStr:[],
                subStr:[],
                listQuery: {
                },
                tableData: []
            };
        },
        computed: {},
        created() {
        },
        mounted() {
            this.getData();
            window.addEventListener('resize', () => {
                this.$echarts.init(document.getElementById('chart')).resize()
            })

        },
        methods: {
            search() {
                this.listQuery.page = 1;
                this.getData()
            },

            getData() {
                this.$http.stationAnalysis(this.listQuery)
                    .then(res => {
                        this.examList = res.data.examList;
                        this.subjectList = res.data.subjectList;
                        this.listQuery.exam_id=res.data.exam_id;
                        this.listQuery.subject_id=res.data.subject_id;
                        this.tableData = res.data.data;
                        const stationNameStr = res.data.stationNameStr.split(",");
                        const scoreAvgStr = res.data.scoreAvgStr.split(",");
                        this.getline(stationNameStr,scoreAvgStr)
                    })
                    .catch(err => {
                        console.log(err);
                    })
            },
            handleEdit(scope) {
                const params={
                    subject_id:this.listQuery.subject_id,
                    exam_id: this.listQuery.exam_id,
                    station_id:scope.stationId,
                    sign:'subjects'
                };
                this.$http.stationDetails(params).then(res=>{
                    this.stationDetails=res.data.data;
                    this.stationTitle=res.data.title;
                    this.dialogTableVisible=true
                })
            },
            //构建图标
            getline(stationNameStr,scoreAvgStr) {
                let chart = this.$echarts.init(document.getElementById('chart'))
                // 绘制图表
                chart.setOption({
                    tooltip: {
                        trigger: "axis"
                    },
                    legend: {
                        orient: 'horizontal', // 'vertical'
                        x: 'right', // 'center' | 'left' | {number},
                        y: 0, // 'center' | 'bottom' | {number}
                        padding:40,
                        data: ["平均成绩"]
                    },
                    calculable: false,
                    xAxis: [{
                        type: "category",
                        data: stationNameStr
                    }],
                    yAxis: [{
                        type: "value"
                    }],
                    series: [
                        {
                            name: "平均成绩",
                            type: "bar",
                            data: scoreAvgStr
                        }]
                });
            }
        },
    };
</script>

<style scoped lang="less">

  .chart {
    width: 100%;
    height: 300px;
    margin-right: 40px;
  }
</style>



// WEBPACK FOOTER //
// src/page/statisticsManage/stationAnalysis.vue